import { createSlice } from '@reduxjs/toolkit';
import { hvhInteractionStates } from 'appConstants';
import {
  takeoverConversation,
  closeSuccessDialog,
  closeErrorDialog,
} from 'redux/actions/hvhConversationControl';
import { getConversation, sendMessage, realtimeMsg, realtimeThreadUpdate } from 'redux/actions';

const initialState = {
  hvhBotInteractionState: null,
  loading: false,
  botResumeAt: null,
  alreadyTakeOver: false,
  error: null,
  showSuccessDialog: false,
  showErrorDialog: false,
};

const updateInteractionState = (state, thread) => {
  if (!thread) return;
  state.hvhBotInteractionState = thread.hvhBotInteractionState || null;
  state.botResumeAt = thread.botResumeAt || null;
};

const hvhConversationControlSlice = createSlice({
  name: 'hvhConversationControl',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConversation.fulfilled, (state, action) => {
      updateInteractionState(state, action.payload.thread);
    });
    builder.addCase(realtimeThreadUpdate, (state, action) => {
      updateInteractionState(state, action.payload.thread);
    });

    builder.addCase(sendMessage.fulfilled, (state, action) => {
      updateInteractionState(state, action.payload.thread);
    });

    builder.addCase(realtimeMsg, (state, action) => {
      updateInteractionState(state, action.payload.thread);
    });

    builder.addCase(closeSuccessDialog, (state) => {
      state.showSuccessDialog = false;
    });

    builder.addCase(closeErrorDialog, (state) => {
      state.showErrorDialog = false;
    });

    builder.addCase(takeoverConversation.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.showSuccessDialog = false;
      state.showErrorDialog = false;
    });

    builder.addCase(takeoverConversation.fulfilled, (state, action) => {
      state.loading = false;
      state.hvhBotInteractionState = hvhInteractionStates.TAKEOVER;
      state.botResumeAt = action.payload.botResumeAt || null;
      state.alreadyTakeOver = action.payload.alreadyTakeOver || false;
      state.showSuccessDialog = true;
      state.showErrorDialog = false;
      state.error = null;
    });

    builder.addCase(takeoverConversation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.showErrorDialog = true;
      state.showSuccessDialog = false;
    });
  },
});

export default hvhConversationControlSlice;
